import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from '@/stores/auth.js'
import { inject } from 'vue';
import routes from './routes.js'
const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});



router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  if(to.meta.requiresAuth && !authStore.currentUser) {
    await authStore.attempt_user() // make at least an attempt to get the user
    if(!authStore.currentUser) {

      authStore.set_intended_url(to.fullPath)
      next({ name: "Login" })
    }
  }

  if(to.meta.requiresOrganizationAccount && !authStore.currentUser.role_organization && !authStore.currentUser.admin) {
    next({ name: 'dashboard' })
  }

  if (to.meta.requiresAuth && !authStore.currentUser) {
    authStore.set_intended_url(to.fullPath)
    next({ name: "Login" })
  } else if (to.meta.isGuest && authStore.currentUser) {
    next({ name: "Home" })
  } else {
    next();
  }
});

router.afterEach((to, from, failure) => {
  if (!failure) {
    setTimeout(() => {
      window.HSStaticMethods.autoInit();
    }, 900)
  }
});
export default router;
